/**
 * Adds width and height (pixels) to the root <svg> tag when it has none, so the file opens at the source image's size
 * instead of stretching to its container. Falls back to the viewBox size when no pixel size is given. Existing width/height are kept.
 */
export function ensureSvgSize(svg: string, w?: number | null, h?: number | null): string {
  const m = /<svg\b[^>]*>/i.exec(svg);
  if (!m) return svg;
  const tag = m[0];
  const has = (a: string) => new RegExp(`\\s${a}\\s*=`, "i").test(tag);
  let W = w && w > 0 ? w : 0, H = h && h > 0 ? h : 0;
  if (!W || !H) {
    const vb = /viewBox\s*=\s*["']\s*[-\d.]+[ ,]+[-\d.]+[ ,]+([\d.]+)[ ,]+([\d.]+)\s*["']/i.exec(tag);
    if (vb) { W = Math.round(Number(vb[1])); H = Math.round(Number(vb[2])); }
  }
  if (!W || !H) return svg;
  let add = "";
  if (!has("width")) add += ` width="${Math.round(W)}"`;
  if (!has("height")) add += ` height="${Math.round(H)}"`;
  if (!add) return svg;
  const next = tag.replace(/^<svg\b/i, m0 => m0 + add);
  return svg.slice(0, m.index) + next + svg.slice(m.index + tag.length);
}
